import { CertGenParams } from '@yandex-int/k-common';

import { TeacherReserve2025Base } from './TeacherReserve2025Base';
import { TeacherHackathonSpring2025 } from './TeacherHackathonSpring2025';
import { TeacherProjectsSpring2025 } from './TeacherProjectsSpring2025';
import { TeacherInternshipSpring2025 } from './TeacherInternshipSpring2025';

const all = [TeacherHackathonSpring2025, TeacherProjectsSpring2025, TeacherInternshipSpring2025] as const;

interface Params extends CertGenParams {
    slug: Parameters<(typeof all)[number]>[0]['slug'];
}

export function TeacherReserve2025(params: Params) {
    for (const getHtml of all) {
        const res = getHtml(params as any);

        if (res) {
            return res;
        }
    }

    return TeacherReserve2025Base(params, {
        title: 'Сертификат',
        achievement: '',
        date: '1970-01-01',
        bgHtml: '',
    });
}
